import {
  AdditionalConfiguration,
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionConfigurationControlType,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { PriceActivityModel } from './price-activity.model';

export class PriceActivityConfiguration extends ReportSectionConfigurationBase {
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_PriceActivity];
  typeName = 'PriceActivityConfiguration';
  nodataLocalizationKeyName = 'bnyPriceActivity';
  readonly reportSection = ReportSection.PriceActivity;
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  maxSize = 4;
  defaultSize = 2;
  minSize = 2;
  name = 'priceActivity';
  displayName = 'Daily DR Price Activity ';

  override readonly configurationControls = [
    {
      name: 'priceActivityDataPointSettingTitle',
      displayName: 'Total Row',
      type: 'totalRowControl'
    }
  ];
  override additionalConfiguration: AdditionalConfiguration = {
    isTotalRowShown: true
  };

  readonly availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'priceDate',
      type: ReportSectionConfigurationControlType.Date,
      unit: 1,
      isStatic: true,
      property: 'date',
      isSelected: true,
      displayName: 'Date',
      canConfigure: false
    },
    {
      name: 'priceHighPrice',
      type: ReportSectionConfigurationControlType.Decimal,
      unit: 2,
      property: 'highPrice',
      isSelected: true,
      displayName: 'High Price, USD',
      canConfigure: true
    },
    {
      name: 'priceLowPrice',
      type: ReportSectionConfigurationControlType.Decimal,
      unit: 2,
      property: 'lowPrice',
      isSelected: true,
      displayName: 'Low Price, USD',
      canConfigure: true
    },
    {
      name: 'priceClosingPrice',
      type: ReportSectionConfigurationControlType.Decimal,
      unit: 2,
      property: 'closePrice',
      isSelected: true,
      displayName: 'Closing Price, USD',
      canConfigure: true
    },
    {
      name: 'priceTradingVolume',
      type: ReportSectionConfigurationControlType.Number,
      unit: 2,
      property: 'tradingVolume',
      isSelected: true,
      displayName: 'DR Trading Vol',
      canConfigure: true
    },
    {
      name: 'priceDollarTradingVolume',
      type: ReportSectionConfigurationControlType.Number,
      unit: 2,
      property: 'dollarTradingVolume',
      isSelected: true,
      displayName: 'DR Dollar Trading Vol, USD',
      canConfigure: true
    }
  ];
}

export interface PriceActivityData {
  [ReportViewModelSection.BnyManagementReport_PriceActivity]: PriceActivityModel;
}
